import { t } from '@lingui/macro';
import { useUpdateEffect } from 'usehooks-ts';

import useCleanStorage from './useCleanStorage';

const useReadCartMissingOrder = data => {
  const { cleanOrderGotoCart } = useCleanStorage(false);

  useUpdateEffect(() => {
    if (!data || data.success !== false || data.unavailable_items) return;

    const defaultErrorMsg = t`This order has been handled already.`;
    cleanOrderGotoCart(data.error ?? defaultErrorMsg);

    // some errors need to re fetch the /settings (eg: disconnected)
    if (data.need_refresh) {
      setTimeout(() => {
        window.location.reload();
      }, 800);
    }
  }, [data]);
};

export default useReadCartMissingOrder;
